import * as Swiper from 'swiper/dist/js/swiper.js'; 

export default class initStoriesSlider {
  constructor() {
    this.container = document.querySelector('.cp-tree-slider');
    if(!this.container) return ;

    this.slider = document.querySelector('.js-cp-tree-slider');
    
    this.initSlider(this.slider)
  }
  initSlider(slider) {

    let isMobile;

    if(window.innerWidth < 768){
      isMobile = true
    }else{
      isMobile = false
    }

    new Swiper(slider, {
      slidesPerView: isMobile ? 1.1 : 1.3,
			spaceBetween: isMobile ? 20 : 82,
      scrollbar: {
        el: slider.querySelector('.swiper-scrollbar'),
        draggable: true,
        spaceBetween: 0
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: '-current',
        clickable: true,
    },
      navigation: {
        nextEl: slider.querySelector('.swiper-nav-arrow-next'),
        prevEl: slider.querySelector('.swiper-nav-arrow-prev')
      },
    });
}
}